import { sendDataLayerEvent } from '../../utils/dataLayerInteractions';
import EventNamesType from '../eventNamesType';

type VariantDataType = {
  variant_name: string;
  variant_value: string;
  item_sku: string;
};

export function sendApplyProductVariantEvent(variantData: VariantDataType) {
  sendDataLayerEvent(EventNamesType.apply_product_variant, {
    custom_data: {
      ...variantData,
    },
  });
}
